export default __webpack_public_path__ + "static/media/hhn4.2805532e.png";